import type { TQueryConstructor } from '@hozana/api/types'
import { normalize } from '@hozana/redux/normalize'

import entities from 'config/entities'

import type { TTag } from 'modules/tag/types'

// If lang or limit are defined, use another query key to avoid caching problems
export const getTagsQuery: TQueryConstructor<{ limit?: number; lang?: string }, number[]> = ({ limit, lang } = {}) => ({
  queryKey: ['getTags', lang, limit].filter(Boolean).join('/'),
  url: `/tags`,
  meta: {
    lang,
    limit,
  },
  normalize: (data: TTag[]) => normalize(data, [entities.tag]),
})

export const getTagQuery: TQueryConstructor<{ slug: string; lang?: string }, number> = ({ slug, lang }) => {
  return {
    queryKey: `getTag/${slug}`,
    url: `/tag/${slug}`,
    meta: {
      lang,
    },
    normalize: (data: TTag) => data && normalize(data, entities.tag),
  }
}
